import FixaPill from "../../../wrappers/FixaPill/FixaPill";
import trackerHelper from "@coworker/app/src/helpers/tracker";
import { FilterValue, SelectFilter } from "../../types/filter";
import { TrackingProps } from "../../types/component";
import { getFilterValueCount } from "../../utils/filter/filtervalue";

interface InputSelectPillMobileProps {
  filter: SelectFilter;
  filterValues: FilterValue[];
  onTriggerFilter: (filterId: string) => void;
  tracking: TrackingProps;
}

export const InputSelectPillMobile = ({
  filter,
  filterValues,
  onTriggerFilter,
  tracking,
}: InputSelectPillMobileProps) => {
  const { id, title } = filter;

  return (
    <FixaPill
      id={`fixapill-${id}`}
      data-testid={`fixapill-${id}`}
      label={title}
      onClick={() => {
        trackerHelper.filter.trackFilterRowClicked(
          tracking.feature,
          tracking.mode,
          filter.id
        );
        onTriggerFilter(id);
      }}
      size="small"
      selected={!!getFilterValueCount(filter, filterValues)}
    />
  );
};
